import { render, staticRenderFns } from "./RecrutamentoComponent.vue?vue&type=template&id=88293a8e&lang=pug&"
var script = {}
import style0 from "./RecrutamentoComponent.vue?vue&type=style&index=0&id=88293a8e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports